const initialState = {
  cache: {},
  user: {},
  role: [],
  role_by_id: {},
  role_by_name: {},

  // // РегиональноеОтделение
  // regionalnoeOtdelenie: [],
  // regionalnoeOtdelenieActive: [],
  // // ЧленФедерации
  // chlenFederatsii: [],
  // chlenFederatsiiActive: [],
  // // Танцор
  // tantsor: [],
  // tantsorActive: [],
  // // Школа
  // shkola: [],
  // shkolaActive: [],
  // // Пара
  // para: [],
  // paraActive: [],
  // // Коллектив
  // kollektiv: [],
  // kollektivActive: [],
  // // Преподаватель
  // prepodavatel: [],
  // prepodavatelActive: [],
  // // Судья
  // sudya: [],
  // sudyaActive: [],
  // // Организатор
  // organizator: [],
  // organizatorActive: [],
  // // Мероприятие
  // meropriyatie: [],
  // meropriyatieActive: [],

  status: [],
  notify: []
}

const mergeByProperty = (target, source, prop) => {
  source.forEach(sourceElement => {
    let targetElement = target.find(targetElement => {
      return sourceElement[prop] === targetElement[prop];
    })
    targetElement ? Object.assign(targetElement, sourceElement) : target.unshift(sourceElement);
  })
}

const objectsFromRoles = (field, roles) => {
  const obj = {}
  if (roles && roles.length > 0) {
    for (let s = 0; s < roles.length; s++) {
      const sm = roles[s];
      if (sm[field] !== null && !sm.dokumentOtmeniZapisiID) {
        if (sm[field]) {
          if (!obj[sm[field].ID]) {
            obj[sm[field].ID] = {...sm[field]}
          }
          if (!obj[sm[field].ID].roles) {
            obj[sm[field].ID].roles = []
          }
          obj[sm[field].ID].roles.push(sm.tipPolzovatelya) 
        }
      }
    }
  }
  return Object.values(obj)
}
const objectsFromRolesActive = (field, roles) => {
  const obj = {}
  if (roles && roles.length > 0) {
    for (let s = 0; s < roles.length; s++) {
      const sm = roles[s];
      if (sm[field] !== null &&
        !sm.dokumentOtmeniZapisiID && sm.dokumentZapisiID && sm.dokumentPodtverzhdeniyaID) {
        if (sm[field]) {
          if (!obj[sm[field].ID]) {
            obj[sm[field].ID] = {...sm[field]}
          }
          if (!obj[sm[field].ID].roles) {
            obj[sm[field].ID].roles = []
          }
          obj[sm[field].ID].roles.push(sm.tipPolzovatelya)
        }
      }
    }
  }
  return Object.values(obj)
}
export function homeReducer(state = initialState, action) {
  switch (action.type) {
    case 'cache':
      return { ...state, cache: action.payload }
    case 'USER':
      return { ...state, user: action.payload }
    case 'FOUNDED':
      return { ...state, founded: action.payload }
    case 'NOTIFY':
      return { ...state, notify: action.payload }
    case 'NOTIFY-UPDATE':
      var tmp = [];
      for (let j = 0; j < state.notify.length; j++) {
        const item = state.notify[j];
        // if ((item.infrastrukturniiStatus.arkhiv == false) || (item.infrastrukturniiStatus.arkhiv == true && item.prochitano == false)) {
        if (item.prochitano == false) {
          //append
          tmp.push(item);
        }
      }
      var s = tmp;
      for (let j = 0; j < action.payload.length; j++) {
        const item = action.payload[j];
        var idx = s.findIndex(i => i.ID == item.ID);
        if (idx === -1) {
          // if ((item.infrastrukturniiStatus.arkhiv == false) || (item.infrastrukturniiStatus.arkhiv == true && item.prochitano == false)) {
          if (item.prochitano == false) {
            //append
            s.push(item);
          }
        } else {
          //update
          s[idx] = item;
        }
      }
      return { ...state, notify: s }
    case 'STATUS':
      return { ...state, status: action.payload }
    case 'STATUS-UPDATE':
      var tmp = [];
      for (let j = 0; j < state.status.length; j++) {
        const item = state.status[j];
        if ((item.status.arkhiv == false) || (item.status.arkhiv == true && item.tipNovayaInfa == true)) {
          //append
          tmp.push(item);
        }
      }
      var s = tmp;
      for (let j = 0; j < action.payload.length; j++) {
        const item = action.payload[j];
        var idx = s.findIndex(i => i.ID == item.ID);
        if (idx === -1) {
          if ((item.status.arkhiv == false) || (item.status.arkhiv == true && item.tipNovayaInfa == true)) {
            //append
            s.push(item);
          }
        } else {
          //update
          s[idx] = item;
        }
      }
      return { ...state, status: s }
    case 'ROLE':
      let o1 = {
        ...state,
        role: action.payload,
        role_by_id: Object.fromEntries(action.payload.map(i => {
          var a = action.payload.filter(j => j.tipPolzovatelya.ID === i.tipPolzovatelya.ID)
          return [i.tipPolzovatelya.ID, a]
        }
        )),
        role_by_name: Object.fromEntries(action.payload.map(i => {
          return [
            i.tipPolzovatelya.nazvanie,
            action.payload.filter(j => j.tipPolzovatelya.nazvanie === i.tipPolzovatelya.nazvanie)
          ]
        }
        )),

        // // РегиональноеОтделение
        // regionalnoeOtdelenie: objectsFromRoles("regionalnoeOtdelenie", action.payload),
        // regionalnoeOtdelenieActive: objectsFromRolesActive("regionalnoeOtdelenie", action.payload),
        // // ЧленФедерации
        // chlenFederatsii: objectsFromRoles("chlenFederatsii", action.payload),
        // chlenFederatsiiActive: objectsFromRolesActive("chlenFederatsii", action.payload),
        // // Танцор
        // tantsor: objectsFromRoles("tantsor", action.payload),
        // tantsorActive: objectsFromRolesActive("tantsor", action.payload),
        // // Школа
        // shkola: objectsFromRoles("shkola", action.payload),
        // shkolaActive: objectsFromRolesActive("shkola", action.payload),
        // // Пара
        // para: objectsFromRoles("para", action.payload),
        // paraActive: objectsFromRolesActive("para", action.payload),
        // // Коллектив
        // kollektiv: objectsFromRoles("kollektiv", action.payload),
        // kollektivActive: objectsFromRolesActive("kollektiv", action.payload),
        // // Преподаватель
        // prepodavatel: objectsFromRoles("prepodavatel", action.payload),
        // prepodavatelActive: objectsFromRolesActive("prepodavatel", action.payload),
        // // Судья
        // sudya: objectsFromRoles("sudya", action.payload),
        // sudyaActive: objectsFromRolesActive("sudya", action.payload),
        // // Организатор
        // organizator: objectsFromRoles("organizator", action.payload),
        // organizatorActive: objectsFromRolesActive("organizator", action.payload),
        // // Мероприятие
        // meropriyatie: objectsFromRoles("meropriyatie", action.payload),
        // meropriyatieActive: objectsFromRolesActive("meropriyatie", action.payload),
      };
      // console.log(o1.role_by_name);
      return o1
    case 'ROLE-UPDATE':
      var s = state.role;
      for (let j = 0; j < action.payload.length; j++) {
        const item = action.payload[j];
        var idx = s.findIndex(i => i.ID == item.ID);
        if (idx === -1) {
          //append
          s.push(item);
        } else {
          //update
          s[idx] = item;
        }
      }
      let o2 = {
        ...state,
        role: s,
        role_by_id: Object.fromEntries(s.map(i => {
          var a = s.filter(j => j.tipPolzovatelya.ID === i.tipPolzovatelya.ID)
          return [i.tipPolzovatelya.ID, a]
        }
        )),
        role_by_name: Object.fromEntries(s.map(i => {
          return [
            i.tipPolzovatelya.nazvanie,
            s.filter(j => j.tipPolzovatelya.nazvanie === i.tipPolzovatelya.nazvanie)
          ]
        }
        )),

        // // РегиональноеОтделение
        // regionalnoeOtdelenie: objectsFromRoles("regionalnoeOtdelenie", s),
        // regionalnoeOtdelenieActive: objectsFromRolesActive("regionalnoeOtdelenie", s),
        // // ЧленФедерации
        // chlenFederatsii: objectsFromRoles("chlenFederatsii", s),
        // chlenFederatsiiActive: objectsFromRolesActive("chlenFederatsii", s),
        // // Танцор
        // tantsor: objectsFromRoles("tantsor", s),
        // tantsorActive: objectsFromRolesActive("tantsor", s),
        // // Школа
        // shkola: objectsFromRoles("shkola", s),
        // shkolaActive: objectsFromRolesActive("shkola", s),
        // // Пара
        // para: objectsFromRoles("para", s),
        // paraActive: objectsFromRolesActive("para", s),
        // // Коллектив
        // kollektiv: objectsFromRoles("kollektiv", s),
        // kollektivActive: objectsFromRolesActive("kollektiv", s),
        // // Преподаватель
        // prepodavatel: objectsFromRoles("prepodavatel", s),
        // prepodavatelActive: objectsFromRolesActive("prepodavatel", s),
        // // Судья
        // sudya: objectsFromRoles("sudya", s),
        // sudyaActive: objectsFromRolesActive("sudya", s),
        // // Организатор
        // organizator: objectsFromRoles("organizator", s),
        // organizatorActive: objectsFromRolesActive("organizator", s),
        // // Мероприятие
        // meropriyatie: objectsFromRoles("meropriyatie", s),
        // meropriyatieActive: objectsFromRolesActive("meropriyatie", s),
      };
      return o2;
    default:
      return state
  }
}
